import { render, staticRenderFns } from "./CreateProductVariance.vue?vue&type=template&id=fb9411e4"
import script from "./CreateProductVariance.vue?vue&type=script&lang=js"
export * from "./CreateProductVariance.vue?vue&type=script&lang=js"
import style0 from "./CreateProductVariance.vue?vue&type=style&index=0&id=fb9411e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports